import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import PatientEditModal from '@/components/patient/PatientEditModal';
import ResetPatientPasswordModal from '@/components/patient/ResetPatientPasswordModal';
import { ClipboardList, RotateCcw } from 'lucide-react';
import type { Overview, PatientDetail, ProfileContentProps } from './types';

type ProfileTabContentProps = {
  patient: PatientDetail;
  localPatient: PatientDetail;
  overview: Overview;
  translatedFlags: string[];
  availableFlags?: ProfileContentProps['availableFlags'];
  onPatientUpdated: (patient: PatientDetail) => void;
};

export default function ProfileTabContent({
  patient,
  localPatient,
  overview,
  translatedFlags,
  availableFlags,
  onPatientUpdated,
}: ProfileTabContentProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Profilo cliente</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-4 md:grid-cols-2">
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Nome completo</p>
            <p className="text-sm text-foreground">
              {patient.display_name ||
                patient.name ||
                [patient.first_name, patient.last_name].filter(Boolean).join(' ') ||
                '—'}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Email</p>
            <p className="text-sm text-foreground">{overview.hero.email || '—'}</p>
          </div>
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Profilo clinico</p>
            <p className="text-sm text-foreground whitespace-pre-wrap">
              {patient.profile || '—'}
            </p>
          </div>
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Creato il</p>
            <p className="text-sm text-foreground">
              {new Date(overview.hero.created_at).toLocaleDateString('it-IT')}
            </p>
          </div>
        </div>
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Flags descrittivi</p>
          {translatedFlags.length === 0 ? (
            <p className="text-sm text-muted-foreground">Nessun flag impostato.</p>
          ) : (
            <div className="flex flex-wrap gap-2">
              {translatedFlags.map((flag) => (
                <Badge key={flag} variant="outline" className="border-border/70 text-foreground">
                  {flag}
                </Badge>
              ))}
            </div>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          <PatientEditModal
            patient={localPatient}
            trigger={
              <Button variant="outline" size="sm" className="gap-2">
                <ClipboardList className="w-4 h-4" />
                Modifica profilo
              </Button>
            }
            onSuccess={(updatedPatient) => onPatientUpdated(updatedPatient)}
            availableFlags={availableFlags}
          />
          <ResetPatientPasswordModal
            patientId={localPatient.id}
            patientName={overview.hero.display_name}
            trigger={
              <Button variant="outline" size="sm" className="gap-2">
                <RotateCcw className="w-4 h-4" />
                Reset password
              </Button>
            }
          />
        </div>
      </CardContent>
    </Card>
  );
}
